module.exports = __webpack_public_path__ + "img/logo-7.adb8695c.svg";